export const BRAND = {
  name: "Vasquez & Son Construction Inc.",
  short: "Vasquez & Son",
  tagline: "Long Island's Trusted Home Improvement Experts",
  phone: "516.943.1740",
  phoneRaw: "5169431740",
  whatsapp: "516.514.4559",
  whatsappRaw: "5165144559",
  email: "Josevasquez1980m@icloud.com",
  hours: "Mon–Sat · 8:00 AM – 6:00 PM",
  areas: ["Nassau County", "Suffolk County", "All of Long Island"],
  logo: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/kk1yr4wr_181652.png",
  photos: [
    "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/n0a4b4n6_182745.jpg",
    "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/d1wjqomr_182747.jpg",
    "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/hc2ow9e9_182743.jpg",
  ],
  // Real Vasquez jobsite photos organized by category
  jobPhotos: [
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/muotvs4w_182749.jpg",
      label: "Siding Installation In Progress",
      category: "Siding",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/rbgnwigl_182757.jpg",
      label: "Full Siding Tear-Off & Prep",
      category: "Siding",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/aqz0lrar_182763.jpg",
      label: "Window Framing & House Wrap",
      category: "Siding",
      location: "Nassau County, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/0d0xrk8b_182779.jpg",
      label: "Siding Sheathing & Tyvek Wrap",
      category: "Siding",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/xq6m31l3_182767.jpg",
      label: "Paver Driveway & Stone Entrance",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/9ioynfte_182769.jpg",
      label: "Stone Steps & Paver Patio",
      category: "Coping",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/4ji44j2z_182797.jpg",
      label: "Fresh Sidewalk Concrete Pour",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/c8wnyvm6_182801.jpg",
      label: "Side-Yard Concrete Walkway",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/wq9r5es2_182807.jpg",
      label: "Custom Deck & Stair Framing",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/bepzjrn6_182799.jpg",
      label: "Full Roof Tear-Off",
      category: "Roofing",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/n0a4b4n6_182745.jpg",
      label: "Flat Roof Restoration",
      category: "Roofing",
      location: "Nassau County, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/d1wjqomr_182747.jpg",
      label: "Roof Hip Metal Detail",
      category: "Roofing",
      location: "Suffolk County, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/1tn7r13l_182825.jpg",
      label: "Siding with Stone Foundation",
      category: "Siding",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/hc2ow9e9_182743.jpg",
      label: "Roof Underlayment Install",
      category: "Roofing",
      location: "Nassau County, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/d16vqc33_182821.jpg",
      label: "Synthetic Roofing Underlayment",
      category: "Roofing",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/c01dp38h_182815.jpg",
      label: "Deck Framing over Foundation",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/c28bexlu_182809.jpg",
      label: "Drywall & Interior Finish",
      category: "Kitchen & Baths",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/a5u5oq44_182819.jpg",
      label: "Interior Doorway & Sheetrock",
      category: "Kitchen & Baths",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/bcwk3uff_182823.jpg",
      label: "GAF FeltBuster Underlayment",
      category: "Roofing",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/8s6cfat2_182827.jpg",
      label: "Foundation & Siding Extension",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/vpk2xyo9_182831.jpg",
      label: "Completed Brick Facade at Dusk",
      category: "Siding",
      location: "Nassau County, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/8hd2sgve_182837.jpg",
      label: "Brick Pointing & Mortar Work",
      category: "Cement Work",
      location: "Long Island, NY",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_siding-solutions/artifacts/8ng5hoja_182841.jpg",
      label: "Scaffold Masonry Restoration",
      category: "Coping",
      location: "Long Island, NY",
    },
  ],
  gallery: {
    kitchen: "https://images.unsplash.com/photo-1665507279638-5b48073c637b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxraXRjaGVuJTIwcmVtb2RlbCUyMGx1eHVyeXxlbnwwfHx8fDE3ODMzNjUyMzV8MA&ixlib=rb-4.1.0&q=85",
    ceramic: "https://images.unsplash.com/photo-1706629503586-2731f65587ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwdGlsZSUyMGZsb29yfGVufDB8fHx8MTc4MzM2NTIzNXww&ixlib=rb-4.1.0&q=85",
    exterior1: "https://images.unsplash.com/photo-1706808849777-96e0d7be3bb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzM2NTIzNHww&ixlib=rb-4.1.0&q=85",
    exterior2: "https://images.unsplash.com/photo-1722421492323-eaf9c401befe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzM2NTIzNHww&ixlib=rb-4.1.0&q=85",
    power: "https://images.unsplash.com/photo-1583517190311-846a7653d8be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwb3dlciUyMHdhc2hpbmclMjBjb25jcmV0ZXxlbnwwfHx8fDE3ODMzNjUyMzV8MA&ixlib=rb-4.1.0&q=85",
  },
  services: [
    { key: "Siding", desc: "Vinyl, fiber-cement & wood siding installation." },
    { key: "Roofing", desc: "Full roof replacements, repairs & underlayment." },
    { key: "Ceramic Floors", desc: "Precision tile installation for any space." },
    { key: "Kitchen & Baths", desc: "Full remodels — cabinets, counters, tile." },
    { key: "Cement Work", desc: "Sidewalks, foundations, driveways, patios." },
    { key: "Coping", desc: "Stone & concrete pool & wall coping." },
    { key: "Power Washing", desc: "Concrete, siding & driveway restoration." },
    { key: "Doormats", desc: "Custom entryway mats & installation." },
  ],
};
